import * as React from 'react';
import { BusIcon, WalkingIcon } from '@cian/ui-kit/prev';
import { ETransportType } from '../../../types/geo';

import * as styles from './styles.css';

interface ITimeToGetProps {
  transportType: ETransportType;
  time: number;
}

export function UndergroundTimeToGet(props: ITimeToGetProps) {
  const { transportType, time } = props;
  const Icon = transportType === ETransportType.Walk ? WalkingIcon : BusIcon;

  return (
    <>
      <div className={styles['icon']}>
        <Icon custom={{ size: '14' }} />
      </div>

      <span>{time} мин.</span>
    </>
  );
}
